import script from "./BadgeMappings.vue?vue&type=script&setup=true&lang=js"
export * from "./BadgeMappings.vue?vue&type=script&setup=true&lang=js"

import "./BadgeMappings.vue?vue&type=style&index=0&id=f6df26d4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f6df26d4"]])

export default __exports__